import type { PatientFinderGender } from "../aggregations";
import type { PatientFinderCommunicationFilter } from "../aggregations";
import type { PatientFinderAppointmentMode } from "./patientFinderAppointmentMode";
import { getPatientFinderResultSubtitle } from "./patientFinderAppointmentMode";
import { formatAppointmentPeriodLabel } from "./resolveAppointmentFetchDateRange";
import type { AppointmentPeriodBounds } from "./resolveAppointmentFetchDateRange";

export interface PatientFinderActiveFilters {
  useAppointmentFilter: boolean;
  appointmentMode: PatientFinderAppointmentMode;
  appointmentPeriod: AppointmentPeriodBounds;
  gender: PatientFinderGender;
  communicationFilter: PatientFinderCommunicationFilter;
  hasAgeFilter: boolean;
}

const GENDER_LABELS: Record<Exclude<PatientFinderGender, "all">, string> = {
  female: "sexo feminino",
  male: "sexo masculino",
  other: "outro sexo",
};

/** Resumo legível dos filtros aplicados no resultado. */
export function buildPatientFinderResultSummary(
  active: PatientFinderActiveFilters,
): string {
  const parts: string[] = [];

  if (active.useAppointmentFilter) {
    const periodLabel = formatAppointmentPeriodLabel(active.appointmentPeriod);
    parts.push(getPatientFinderResultSubtitle(active.appointmentMode, periodLabel));
  }

  if (active.gender !== "all") {
    parts.push(GENDER_LABELS[active.gender]);
  }

  if (active.communicationFilter === "never") {
    parts.push("ainda não comunicados (FluxZap)");
  } else if (active.communicationFilter === "already") {
    parts.push("já comunicados (FluxZap)");
  }

  if (active.hasAgeFilter) {
    parts.push("faixa etária informada");
  }

  if (parts.length === 0) {
    return "todos os pacientes da organização";
  }

  return parts.join(" · ");
}
